import { Sky } from "@react-three/drei";
import { useLocation, useNavigate } from "react-router-dom";
import MapLabel from "./MapLabel";
import { Gsc } from "vmi-gsc";
import { useGLTF } from "@common/hooks/useGLTF";
import { Html } from "@react-three/drei";

const TheLocation = ({
  splatDataOnLoad,
  recordMode = false,
  renderSplat = true,
}) => {
  const pathname = useLocation().pathname;

  return (
    <group visible={pathname === "/the-location"}>
      {renderSplat && (
        <>
          <Gsc
            onLoaded={() => {
              splatDataOnLoad("loc");
            }}
            src="assets/splats/context_2_faded.splat"
          />

          <Sky />
        </>
      )}

      {pathname === "/the-location" && <Selector />}

      <MapLabel title="Kensington Gardens" position={[-10, 2, 14]} />
      <MapLabel title="Hyde Park" walk="18" position={[6, 2, 10]} />
      <MapLabel title="Selfridges" walk="25" position={[17, 1.2, 10]} />
      <MapLabel title="The Shard" position={[80, 9, 25]} />
      <MapLabel
        title="Paddington Station"
        walk="11"
        position={[-0.55, 0.6, 1.3]}
      />
      <MapLabel title="Regents Park" walk="16" position={[7, 2, -7]} />
      <MapLabel title="Marylebone" walk="20" position={[17, 2, 0]} />
      <MapLabel title="Lords Cricket Ground" position={[0, 2, -9]} />
      <MapLabel title="Little Venice" walk="15" position={[0, 2, 0]} />
      <MapLabel title="Wembley Stadium" position={[-107, 15, -60]} />
    </group>
  );
};

export const Selector = () => {
  const { nodes } = useGLTF("assets/models/selector.glb");

  return (
    <>
      {/* <Html position={[-0.15, 1.1, 0.6]} center={true}> */}
      <Html position={[-0.15, 0.6, 0.6]} center={true}>
        <div
          style={{
            transition: "opacity 0.3s ease-in-out",
            width: "max-content",
            padding: ".3rem .6rem",

            backgroundColor: "var(--secondary)",
            border: "1px solid var(--primary)",
            borderRadius: "10px",
            display: "flex",
            color: "var(--primary)",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            flexDirection: "column",
            fontSize: ".4rem",
            position: "relative",
          }}
        >
          <h1>THE BURTON</h1>
        </div>
      </Html>
      <group scale={0.0001}>
        <mesh
          renderOrder={-999900}
          visible={false}
          geometry={nodes["mesh_0"].geometry}
        >
          <meshBasicMaterial
            colorWrite={false}
            depthTest={true}
            depthWrite={true}
            color="#DAD6C1"
          />
        </mesh>
      </group>
    </>
  );
};

export default TheLocation;
